import { useEffect, useState } from "react";

const KEY = "sb_cookies";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const set = (v) => {
    localStorage.setItem(KEY, v);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed left-4 right-4 bottom-20 md:left-auto md:right-6 md:bottom-20 md:max-w-sm z-40 sb-card rounded-lg p-4 sb-fade-up"
    >
      <p className="text-sm font-display font-bold mb-1">We use cookies</p>
      <p className="text-xs mb-3" style={{ color: "var(--sb-text-secondary)" }}>
        We use essential cookies to operate this site and analytics to understand how our offerwall
        performs. By clicking accept, you agree to our use of cookies.
      </p>
      <div className="flex gap-2">
        <button
          data-testid="cookie-accept"
          onClick={() => set("accepted")}
          className="sb-btn-primary px-4 py-2 text-xs uppercase tracking-wider"
        >
          Accept
        </button>
        <button
          data-testid="cookie-decline"
          onClick={() => set("declined")}
          className="sb-btn-outline px-4 py-2 text-xs uppercase tracking-wider"
        >
          Decline
        </button>
      </div>
    </div>
  );
}
